// CECertification.jsx - Complete updated code with VERIFIED WORKING Pexels image
import React from "react";

export default function CECertification() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            CE Certification
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            CE Certification for European Market Access
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists manufacturers with CE Certification to
            demonstrate compliance with EU safety, health, and environmental
            protection requirements for legal market access across 27 EU countries.
          </p>
          <p className="text-gray-700">
            From directive identification and technical file preparation through
            Notified Body coordination and Declaration of Conformity, the process
            ensures complete CE marking compliance for machinery, electronics,
            medical devices, and construction products.
          </p>
        </div>

        {/* Right: VERIFIED WORKING IMAGE - Industrial machinery compliance testing */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/414720/pexels-photo-414720.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Industrial machinery undergoing CE certification compliance testing"
              className="w-full aspect-square object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* PROFESSIONAL SUPPORT & DOCUMENTS SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Professional compliance support */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Professional Compliance Support by Hawkins &amp; Brooks
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks provides end-to-end CE marking compliance
              support from directive identification through market surveillance readiness.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Applicable EU directive identification (Machinery, LVD, EMC,
                  Medical Device, PPE, Construction Products) and harmonized standards selection.
                </li>
                <li>
                  Technical construction file preparation including risk
                  assessment, design calculations, test plans, and conformity evaluation.
                </li>
                <li>
                  Notified Body coordination for modules requiring independent
                  assessment (Annex modules B+E, G+F, H) and EU-Type Examination certification.
                </li>
                <li>
                  Declaration of Conformity drafting, CE marking affixation guidance,
                  and 10-year technical documentation retention compliance.
                </li>
              </ul>
            </div>
          </div>

          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for CE Certification
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks assists in developing the complete Technical
              Documentation File required for CE marking self-certification or Notified Body review.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Detailed product specifications, drawings, schematics, and bill of materials.</li>
                <li>
                  Technical documentation including risk analysis, design
                  calculations, manufacturing drawings, and user manuals.
                </li>
                <li>
                  Test reports from accredited labs demonstrating compliance with
                  harmonized standards (essential requirements verification).
                </li>
                <li>
                  EU Declaration of Conformity template and DoP (Declaration of
                  Performance) for construction products under CPR 305/2011.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm delivers specialized EU market access expertise with proven
              success securing CE marking across multiple product categories.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  International Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete mastery of 20+ EU directives, conformity assessment
                  modules, Notified Body requirements, and Blue Guide implementation.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Certification Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise technical file structuring, test plan development, and
                  Notified Body coordination ensuring first-time CE marking approval.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Advisory Services
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end support from directive identification through market
                  surveillance readiness, significant modification handling, and EU importer compliance.
                </p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="flex flex-col justify-center">
            <div className="bg-gray-50 border border-yellow-100 rounded-2xl p-6 shadow-sm">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Unlock EU Market Access Today
              </h3>
              <p className="text-gray-700 mb-5">
                Connect with Hawkins &amp; Brooks to achieve CE Certification
                compliance and legally place your products on the European market
                with complete safety, regulatory, and documentation assurance.
              </p>
              <div className="flex flex-wrap gap-3">
                <a
                  href="/contact"
                  className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
                >
                  Get Consultation
                </a>
                <a
                  href="tel:+919217468906"
                  className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
                >
                  Call Hawkins &amp; Brooks
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
